(ns fablo-offers.common.state
  (:refer-clojure :exclude [atom])
  (:require
   ["jotai" :as j]
   ["jotai/query" :as jq]
   ["jotai/utils" :as ju]
   [fablo-offers.common.api :as api]
   [fablo-offers.common.utils :as u]
   ["react-query" :as rq]
   [cljs.reader :as edn]
   [cljs-bean.core :refer [->clj ->js] :as bean]))

(defn atom [v]
  (j/atom v))

(defprotocol IUpdate
  (-update! [a v]))

(defn use-atom [a]
  (let [[value setter] (j/useAtom a)]
    (reify
      IReset
      (-reset! [_ v] (setter v))
      ISwap
      (-swap! [_ f] (setter (f value)))
      (-swap! [_ f a] (setter (f value a)))
      (-swap! [_ f a b] (setter (f value a b)))
      (-swap! [_ f a b xs] (setter (apply f value a b xs)))
      IDeref
      (-deref [_] value)
      IUpdate
      (-update! [_ v] (setter v)))))

(defn debug-label [a label]
  (aset a "debugLabel" label))

(defn atom-with-query [f]
  (jq/atomWithQuery
   (fn [get]
     (-> (f get)
         u/js-camel-case-keys))))

(defn js-key [[query params]]
  #js [(str query) (clj->js params)])

(defn api-atom [prefix f]
  (atom-with-query
   (fn [get]
     (let [[query-id params] (f get)]
       {:query-key (js-key (into prefix [query-id params]))
        :query-fn #(api/fetch query-id params)}))))

(defn default-query-fn [params]
  (let [{:keys [queryKey]} (->clj params)]
    (apply api/fetch queryKey)))

(def query-client
  (rq/QueryClient.
   (->js
    {:defaultOptions
     {:queries
      {:queryFn default-query-fn
       :retry (fn [count err]
                (and
                 ;; do not retry after status 4xx
                 (not (and (map? err) (<= 400 (:status err) 499)))
                 (<= count 3)))}}})))

(defn invalidate-queries! [key-prefix]
  (.invalidateQueries query-client
                      (cond
                        (= 2 (count key-prefix)) (js-key key-prefix)
                        :else (map str key-prefix))))

;(defn use-query [])
(defn use-mutation [f opts]
  (->clj (rq/useMutation f (u/js-camel-case-keys opts))))

(defn use-tx [tx-id opts]
  (use-mutation
   #(api/tx tx-id %)
   opts))

(defn use-query
  ([query-key query-fn? opts]
   (let [opts (assoc opts :keepPreviousData true)]
     (->clj
      (if query-fn?
        (rq/useQuery (js-key query-key)
                     query-fn?
                     (u/js-camel-case-keys opts))
        (rq/useQuery (js-key query-key)
                     (u/js-camel-case-keys opts))))))
  ([query-key opts] (use-query query-key nil opts))
  ([query-key] (use-query query-key nil nil)))


(defn atom-with-storage [key default]
  (ju/atomWithStorage
   key default
   #js {:getItem
        (fn [k]
          (if-let [v (.getItem js/localStorage k)]
            (edn/read-string v)
            (throw (js/Error. "no value stored"))))
        :setItem
        (fn [k v]
          (.setItem js/localStorage k (pr-str v)))}))

(defn atom-with-session-storage [key default]
  (ju/atomWithStorage
   key default
   #js {:getItem
        (fn [k]
          (if-let [v (.getItem js/sessionStorage k)]
            (edn/read-string v)
            (throw (js/Error. "no value stored"))))
        :setItem
        (fn [k v]
          (.setItem js/sessionStorage k (pr-str v)))}))
